<template>
  <div>
    <h1 class="text-center mb-3" v-if="hasRental">Kostnader / Inntekter</h1>
    <h1 class="text-center mb-3" v-else>Kostnader</h1>
    <v-layout wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar color="accent" :dark="protocol.dark">
            <v-toolbar-side-icon>
              <v-icon>mdi-calendar-range</v-icon>
            </v-toolbar-side-icon>

            <v-toolbar-title>Felleskostnader / Utgifter</v-toolbar-title>
          </v-toolbar>

          <v-list subheader dense>
            <v-subheader v-if="stepValues.monthly.length == 0">Ingen kostnader er lagt til</v-subheader>
            <template v-for="(item, index) in stepValues.monthly">
              <v-divider v-if="index == 0" :key="index+'dividerd'"></v-divider>
              <v-list-tile avatar :key="index">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <h4>{{item.name}}</h4>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>{{item.cost}},- /mnd</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple v-on:click="removeMonthly(index)">
                    <v-icon color="grey lighten-1">mdi-close-circle</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider v-if="index + 1 < stepValues.monthly.length" :key="index+'divider'"></v-divider>
            </template>
          </v-list>

          <v-divider></v-divider>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card-text style="height: 10px; position: relative" @click="monthlyDialog = true">
          <v-btn absolute fab top right small color="green" :dark="protocol.dark">
            <v-icon>mdi-plus-circle</v-icon>
          </v-btn>
        </v-card-text>
      </v-flex>
      <v-flex xs12 sm6>
        <v-card class="mr-sm-2 mt-4">
          <v-toolbar color="accent" :dark="protocol.dark">
            <v-toolbar-side-icon>
              <v-icon>mdi-bank</v-icon>
            </v-toolbar-side-icon>
            <v-toolbar-title>Fellesgjeld</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    box
                    solo
                    hide-details
                    label="Fellesgjeld"
                    type="number"
                    v-model="stepValues.debt"
                    suffix="NOK"
                    @input="updateFields"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6>
        <v-card class="ml-sm-2 mt-4">
          <v-toolbar color="accent" :dark="protocol.dark">
            <v-toolbar-side-icon>
              <v-icon>mdi-cash</v-icon>
            </v-toolbar-side-icon>
            <v-toolbar-title>Fellesformue</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    box
                    solo
                    hide-details
                    label="Fellesformue"
                    type="number"
                    v-model="stepValues.assets"
                    suffix="NOK"
                    @input="updateFields"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 v-if="hasRental">
        <v-card class="ml-sm-2 mt-4">
          <v-toolbar color="accent" :dark="protocol.dark">
            <v-toolbar-side-icon>
              <v-icon>mdi-key-plus</v-icon>
            </v-toolbar-side-icon>
            <v-toolbar-title>Utleie</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-text-field
                    box
                    hide-details
                    label="Antall utleieenheter"
                    type="number"
                    v-model="stepValues.rental.units"
                    @input="updateFields"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    box
                    hide-details
                    label="Total leieinntekt"
                    type="number"
                    v-model="stepValues.rental.rent"
                    suffix="NOK"
                    @input="updateFields"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>      
    </v-layout>
    <v-dialog v-model="monthlyDialog" max-width="600px" :dark="protocol.dark">
      <v-card>
        <v-card-title>
          <span class="headline">Ny felleskostnad</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs8>
                <v-text-field v-model="currentCost.name" label="Kostnadstype" @input="updateFields"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="currentCost.cost"
                  type="number"
                  label="Kostnad /nmd"
                  @input="updateFields"
                  suffix="NOK"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="monthlyDialog = false">Lukk</v-btn>
          <v-btn color="primary" flat @click="createMonthly">Legg til</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <StepButtons @next-page="next" @previous-page="previous" />
  </div>
</template>

<script>
import step from "../../../mixins/step";
export default {
  mixins: [step],
  data() {
    return {
      currentCost: { name: "", cost: "" },
      monthlyDialog: false,
    };
  },
  computed: {
    hasRental: {
      get() {
        if (this.protocol.saved_values.steps['inspection-basics']) {
          return this.protocol.saved_values.steps['inspection-basics'].saved_values.hasRental;
        }
        return false;
      }
    }
  },
  methods: {
    removeMonthly: function(index) {
      this.stepValues.monthly.splice(index, 1);
      this.$emit("save-state");
    },
    createMonthly: function() {
      this.stepValues.monthly.push(this.currentCost);
      this.currentCost = { name: "", cost: "" };
      this.monthlyDialog = false;
      this.$emit("save-state");
    }
  }
};
</script>